// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1TwfI","cell":"ColumnAccessor_cell__1Nahi","firstCellAccent":"ColumnAccessor_firstCellAccent__N2r-h"};